import repository from '@/repositories/Repository'

const resource = '/api/query-reservation'

/**
 * 分析予約リポジトリ
 */
export default {
  /**
   * 分析予約の一覧データを取得
   */
  getQueryReservationRows(finished) {
    return repository.giggle
      .get(resource, {
        params: {
          finished,
        },
      })
      .then(r => r.data)
  },
  /**
   * 分析予約の画面用分析条件を取得（単体）
   */
  getQueryFilter(reservationId) {
    return repository.giggle
      .get(`${resource}/${reservationId}`)
      .then(r => r.data)
  },
  /**
   * 分析予約の予約条件を取得（単体）
   */
  getReservationConfig(reservationId) {
    return repository.giggle
      .get(`${resource}/config/${reservationId}`)
      .then(r => r.data)
  },
  /**
   * 分析予約の登録/更新（リソース毎）
   */
  reserveQuery(resourceName, postData) {
    return repository.giggle
      .post(`${resource}/${resourceName}`, postData)
      .then(r => r.data)
  },
  /**
   * 分析予約のタイトル更新
   */
  updateTitle(reservationId, title) {
    return repository.giggle
      .post(`${resource}/${reservationId}/title`, { title })
      .then(r => r.data)
  },
  /**
   * 予約上限と予約可能数を取得
   */
  getReservationQuota() {
    return repository.giggle.get(`${resource}/quota`).then(r => r.data)
  },
  /**
   * 予約の削除
   */
  deleteReservation(reservationId) {
    return repository.giggle
      .delete(`${resource}/${reservationId}`)
      .then(r => r.data)
  },
  /**
   * 予約による分析履歴が本日実行分があるかを取得
   */
  getReservationExecutionStatus() {
    return repository.giggle.get(`${resource}/has-recent`).then(r => r.data)
  },
  /**
   * ユーザーが処理するべき予約レコードの存在チェック
   * ステータスが RequiresUpdate | NextReservationFailed が残っていないかを取得
   */
  hasActionRequiredReservation() {
    return repository.giggle
      .get(`${resource}/has-action-required`)
      .then(r => r.data)
  },
  /**
   * 予約IDをもとに予約レコードのステータスを'Completed'に更新する。（対応済みにする）
   */
  closeReservation(reservationId) {
    return repository.giggle
      .post(`${resource}/close/${reservationId}`)
      .then(r => r.data)
  },
  /**
   * 予約IDをもとに予約レコードのステータスを'Paused'に更新する。
   * 定期実行を一時停止する
   */
  pauseReservation(reservationId) {
    return repository.giggle
      .post(`${resource}/pause/${reservationId}`)
      .then(r => r.data)
  },
}
